
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_14yj0_115i1_5",
  "no-gutters": "awsui_no-gutters_14yj0_115i1_18",
  "grid-column": "awsui_grid-column_14yj0_115i1_22",
  "colspan-1": "awsui_colspan-1_14yj0_115i1_31",
  "push-1": "awsui_push-1_14yj0_115i1_35",
  "pull-1": "awsui_pull-1_14yj0_115i1_38",
  "colspan-2": "awsui_colspan-2_14yj0_115i1_41",
  "push-2": "awsui_push-2_14yj0_115i1_45",
  "pull-2": "awsui_pull-2_14yj0_115i1_48",
  "colspan-3": "awsui_colspan-3_14yj0_115i1_51",
  "push-3": "awsui_push-3_14yj0_115i1_55",
  "pull-3": "awsui_pull-3_14yj0_115i1_58",
  "colspan-4": "awsui_colspan-4_14yj0_115i1_61",
  "push-4": "awsui_push-4_14yj0_115i1_65",
  "pull-4": "awsui_pull-4_14yj0_115i1_68",
  "colspan-5": "awsui_colspan-5_14yj0_115i1_71",
  "push-5": "awsui_push-5_14yj0_115i1_75",
  "pull-5": "awsui_pull-5_14yj0_115i1_78",
  "colspan-6": "awsui_colspan-6_14yj0_115i1_81",
  "push-6": "awsui_push-6_14yj0_115i1_85",
  "pull-6": "awsui_pull-6_14yj0_115i1_88",
  "colspan-7": "awsui_colspan-7_14yj0_115i1_91",
  "push-7": "awsui_push-7_14yj0_115i1_95",
  "pull-7": "awsui_pull-7_14yj0_115i1_98",
  "colspan-8": "awsui_colspan-8_14yj0_115i1_101",
  "push-8": "awsui_push-8_14yj0_115i1_105",
  "pull-8": "awsui_pull-8_14yj0_115i1_108",
  "colspan-9": "awsui_colspan-9_14yj0_115i1_111",
  "push-9": "awsui_push-9_14yj0_115i1_115",
  "pull-9": "awsui_pull-9_14yj0_115i1_118",
  "colspan-10": "awsui_colspan-10_14yj0_115i1_121",
  "push-10": "awsui_push-10_14yj0_115i1_125",
  "pull-10": "awsui_pull-10_14yj0_115i1_128",
  "colspan-11": "awsui_colspan-11_14yj0_115i1_131",
  "push-11": "awsui_push-11_14yj0_115i1_135",
  "pull-11": "awsui_pull-11_14yj0_115i1_138",
  "colspan-12": "awsui_colspan-12_14yj0_115i1_141",
  "push-12": "awsui_push-12_14yj0_115i1_145",
  "pull-12": "awsui_pull-12_14yj0_115i1_148",
  "push-0": "awsui_push-0_14yj0_115i1_151",
  "pull-0": "awsui_pull-0_14yj0_115i1_154",
  "offset-1": "awsui_offset-1_14yj0_115i1_157",
  "offset-2": "awsui_offset-2_14yj0_115i1_160",
  "offset-3": "awsui_offset-3_14yj0_115i1_163",
  "offset-4": "awsui_offset-4_14yj0_115i1_166",
  "offset-5": "awsui_offset-5_14yj0_115i1_169",
  "offset-6": "awsui_offset-6_14yj0_115i1_172",
  "offset-7": "awsui_offset-7_14yj0_115i1_175",
  "offset-8": "awsui_offset-8_14yj0_115i1_178",
  "offset-9": "awsui_offset-9_14yj0_115i1_181",
  "offset-10": "awsui_offset-10_14yj0_115i1_184",
  "offset-11": "awsui_offset-11_14yj0_115i1_187",
  "restore-pointer-events": "awsui_restore-pointer-events_14yj0_115i1_191"
};
  